import { render } from "./DetailsViewComponent.vue?vue&type=template&id=74628b2a"
import script from "./DetailsViewComponent.vue?vue&type=script&lang=js"
export * from "./DetailsViewComponent.vue?vue&type=script&lang=js"

import "./DetailsViewComponent.vue?vue&type=style&index=0&id=74628b2a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__